import State from '@/helpers/pattern/state';
import {BitacoraArchivoModel} from "@/models/bitacoras/bitacora-archivo";
import CombosAPI from "@/services/catalogos";
import PerfilUsuarioAPI from "@/services/seguridad/perfilUsuario";

/**
 * State Pattern for Comercio form
 */
export default class BitacoraArchivoStates extends State{
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */
  constructor(data){
    super(data);
  }

  /**
   * General Methods
   */
  base(){
    return {
      clear({$setState}){
        $setState('initial');
      }
      
      , resetModel({$data}){
        $data.bitacora = new BitacoraArchivoModel();
      }
      , resetValidators({$data}){
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({$data}){
        return $data.hasErrors($data.$v.bitacora) || $data.view.action.submit.busy;
      }
      , async loadCombos({$data}){
        const responseCombosComerciosActive = await CombosAPI.get({tipo:'comercios'});
        const valueComercios = responseCombosComerciosActive.data.results.combo;
        
        if($data.$store.getters.getUserData){
          let username = $data.$store.getters.getUserData.username;
          const response = await PerfilUsuarioAPI.get({username});
          const {data:{results:{usuario}}} = response;
          let arrayComercios =  usuario.comercio ? usuario.comercio.split(",") : null;
          const filter = valueComercios.filter(valueFilter => arrayComercios ? arrayComercios.includes(valueFilter.code.toString()) : valueFilter);
          $data.view.elem.select.comercio.options = filter;
        }else{
          $data.view.elem.select.comercio.options = valueComercios;
        }
        const responseCombosTipoArchivos = await CombosAPI.get({tipo:'tipoArchivos'});
        $data.view.elem.select.tipoArchivo.options = responseCombosTipoArchivos.data.results.combo;
      }
    }
  }

  /**
   * States and its methods
   */
  states(){
    return{
      initial:{
        $constructor:function({$data}){
            //Reset Models and validators
            this.resetModel();
            this.resetValidators();
            //View configuration
            $data.view.elem.button.submit.text ="Buscar";
            try{
                this.loadCombos($data);
            }catch(e){

            }
            
        }
        
        
      }
      
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/bitacoras/documento/archivo-states.js